export const dpdStatus90: string = "DPD 90+";
export const roleAdmin: string = "Admin";
export const roleAgentManager: string = "Agent-Manager";
export const roleLegalManager: string = "Legal-Manager";
export const roleLegalAgent: string = "Legal-Agent";
export const roleAgent: string = "Agent";